/**
 * How a game master reads, on the name plate and in the chat (ADR 0025):
 * `[GM]` before the name, in a violet that no aura, rarity or townsperson wears.
 */
export const GM_NAME_COLOR = 0xb77dff;

export function gmName(name: string, gm: boolean): string {
  return gm ? `[GM]${name}` : name;
}
